/* Zoekhulp: springt bij als de zoekopdracht niets oplevert.

   Shopify's zoekfunctie doet al veel goed — "long & strong", "long strong" en
   zelfs "silverr savior" leveren gewoon resultaten. Twee dingen lukken niet:

     longstrong    aaneengeschreven, geen enkel woord matcht
     lng strong    één kapot woord, en omdat Shopify de woorden met EN
                   combineert valt daarmee de hele zoekopdracht weg

   Deze hulp draait pas als er nul resultaten zijn en probeert dan drie dingen,
   in deze volgorde. Zonder JavaScript verandert er niets: dan blijft de gewone
   "niets gevonden"-tekst staan, en dat is beter dan een half werkende zoekbalk.
*/

(function () {
  'use strict';

  var blok = document.querySelector('[data-zoekhulp]');
  if (!blok) return;

  var vraag = (blok.dataset.zoekhulp || '').trim();
  if (!vraag) return;

  var teksten = window.ncStrings || {};
  var synoniemen = {};
  try {
    // "keratine=keratin, longstrong=long strong" uit de sectie-instelling
    (blok.dataset.synoniemen || '').split(',').forEach(function (paar) {
      var stuk = paar.split('=');
      if (stuk.length === 2) synoniemen[stuk[0].trim().toLowerCase()] = stuk[1].trim();
    });
  } catch (e) { /* een scheve instelling mag de zoekpagina niet slopen */ }

  function zoek(q) {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
                 '&resources[type]=product&resources[limit]=8')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return [];
        return (d.resources.results.products || []);
      })
      .catch(function () { return []; });
  }

  /* Een aaneengeschreven woord op elke plek proberen te splitsen. Beide helften
     minstens drie letters, anders levert het alleen ruis op. */
  function splitsingen(woord) {
    var uit = [];
    for (var i = 3; i <= woord.length - 3; i++) {
      uit.push(woord.slice(0, i) + ' ' + woord.slice(i));
    }
    return uit;
  }

  function pogingen() {
    var lijst = [];
    var laag = vraag.toLowerCase();

    if (synoniemen[laag]) lijst.push({ q: synoniemen[laag], soort: 'correctie' });

    vraag.split(/\s+/).forEach(function (woord) {
      if (synoniemen[woord.toLowerCase()]) {
        lijst.push({ q: vraag.replace(woord, synoniemen[woord.toLowerCase()]), soort: 'correctie' });
      }
      if (woord.length >= 7 && !/\d/.test(woord)) {
        splitsingen(woord).forEach(function (s) {
          lijst.push({ q: vraag.replace(woord, s), soort: 'correctie' });
        });
      }
    });

    /* Woorden los met een jokerteken en met OF ertussen: dan blokkeert één
       verkeerd getypt woord de rest niet meer. */
    var delen = vraag.split(/\s+/).filter(function (w) { return w.length >= 3; });
    if (delen.length > 1) {
      lijst.push({ q: delen.map(function (w) { return w + '*'; }).join(' OR '), soort: 'breder' });
    }
    if (delen.length === 1) lijst.push({ q: delen[0] + '*', soort: 'breder' });

    return lijst;
  }

  function toon(producten, poging) {
    if (!producten.length) return;

    var kop = document.createElement('p');
    kop.className = 'col__leeg zoekhulp__kop';
    // Bij een bredere poging staat er niets te verbeteren: dan is "Bedoelde je
    // 'silverr savior'?" alleen maar verwarrend, want dat typte de bezoeker net.
    kop.textContent = poging.soort === 'correctie'
      ? (teksten.didYouMean || 'Bedoelde je') + ' \u201C' + poging.q + '\u201D?'
      : (teksten.similarResults || 'Dit lijkt erop:');

    var lijst = document.createElement('ul');
    lijst.className = 'zoekhulp__lijst';
    lijst.setAttribute('role', 'list');

    producten.slice(0, 6).forEach(function (p) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'zoekhulp__item';
      a.href = p.url;

      if (p.image) {
        var img = document.createElement('img');
        img.className = 'zoekhulp__beeld';
        img.src = p.image;
        img.alt = '';
        img.loading = 'lazy';
        a.appendChild(img);
      }

      var tekst = document.createElement('span');
      tekst.className = 'zoekhulp__tekst';
      var naam = document.createElement('span');
      naam.className = 'zoekhulp__naam';
      naam.textContent = p.title;
      tekst.appendChild(naam);
      if (p.price) {
        var prijs = document.createElement('span');
        prijs.className = 'zoekhulp__prijs';
        prijs.textContent = p.price;
        tekst.appendChild(prijs);
      }
      a.appendChild(tekst);
      li.appendChild(a);
      lijst.appendChild(li);
    });

    blok.appendChild(kop);
    blok.appendChild(lijst);
  }

  /* Eén voor één proberen en stoppen zodra er iets is. Alles tegelijk zou de
     winkel onnodig belasten en de volgorde onvoorspelbaar maken. */
  var kandidaten = pogingen();

  (function volgende(i) {
    if (i >= kandidaten.length) return;
    zoek(kandidaten[i].q).then(function (producten) {
      if (producten.length) {
        toon(producten, kandidaten[i]);
      } else {
        volgende(i + 1);
      }
    });
  })(0);
})();
